function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5359",
  "data-name": "Rectangle 5359",
  width: 24,
  height: 24,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_60652",
  "data-name": "Path 60652",
  d: "M13.5,5.5a2,2,0,1,0-2-2A2.006,2.006,0,0,0,13.5,5.5ZM18.25,9a.755.755,0,0,0-.75.75v1.03A4.808,4.808,0,0,1,14.7,8.6L13.7,7a2.155,2.155,0,0,0-1.84-1,1.79,1.79,0,0,0-1.78,1.44L7.25,21.76A1.036,1.036,0,0,0,8.27,23a1.049,1.049,0,0,0,1.02-.81L10.9,15,13,17v5a1,1,0,0,0,2,0V16.36a1.989,1.989,0,0,0-.62-1.45L12.9,13.5l.6-3a7.3,7.3,0,0,0,4,2.34v9.41a.75.75,0,0,0,1.5,0V9.75A.755.755,0,0,0,18.25,9ZM7.43,13.13l-2.12-.41a1,1,0,0,1-.79-1.17l.76-3.93A2,2,0,0,1,7.62,6.04l1.16.23Z"
});

function SvgHiking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hiking_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiking);
export default __webpack_public_path__ + "static/media/hiking.6f0614d1.svg";
export { ForwardRef as ReactComponent };